import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { PIXEL_BASED_REPORT_ID } from './pixelBasedReportId';

const reportId = PIXEL_BASED_REPORT_ID;

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.AUDIENCE_NAME.field,
        FIELDS.ACCOUNT_DESCRIPTION.field,
        FIELDS.AUDIENCE_TYPE.field,
        FIELDS.STATUS.field,
        FIELDS.CONDITIONS.field,
        FIELDS.AUDIENCE_SIZE.field,
        FIELDS.AUDIENCE_CAMPAIGN_USING.field,
        FIELDS.LAST_MODIFY_BY.field,
        FIELDS.LAST_MODIFY_ON.field,
        FIELDS.LAST_REFRESHED.field,
    ].map(field => generateColumnId(reportId, field)),
};

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.AUDIENCE_NAME.field,
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.AUDIENCE_TYPE.field,
    FIELDS.STATUS.field,
    FIELDS.CONDITIONS.field,
    FIELDS.AUDIENCE_SIZE.field,
    FIELDS.AUDIENCE_CAMPAIGN_USING.field,
    FIELDS.LAST_MODIFY_BY.field,
    FIELDS.LAST_MODIFY_ON.field,
    FIELDS.ACTIONS_COLUMN.field,
    FIELDS.LAST_REFRESHED.field,
].map(field => generateColumnId(reportId, field));

export { customColumns, defaultColumns };
